import React, { memo } from 'react'
import styles from './cards.scss'
import classNames from 'classnames'
import {
    CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED,
    CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED,
    CLAN_SUPPLY_PROGRESSION_TITLE,
    CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP,
    CLAN_SUPPLY_SLASH,
} from '../translations'
import { useSelector } from 'react-redux'
import ClanSupplyFooterProgression from './ClanSupplyFooter/ClanSupplyFooterProgression'
import { selectMapProgress, selectMapSettings } from '../selectors'
import { TANK_STATUSES } from './clan_quests_constants'
import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap/lib/helpers/web_to_client'
import { openClanSupplyProgression } from '../../../helpers/web_to_client'
import Tooltip from 'react-wot-bootstrap/lib/components/Tooltip/Tooltip'
import { thousands } from '@wotfe/formatters'
import PropTypes from 'prop-types'

const tooltipId = 'tooltipId-ClanSupplyProgression'

const ClanSupplyProgressionCard = memo(({
    tourCoin,
}) => {
    const mapSettings = useSelector(selectMapSettings)
    const mapProgress = useSelector(selectMapProgress)
    const isTankAvailable = mapProgress.finalRegion.status === TANK_STATUSES.AVAILABLE
    const explodedValue = thousands(mapProgress.regionsUnlocked)
    const countValue = thousands(mapSettings.regionsCount)

    return (
        <div
            className={classNames(styles.card, styles.clanSupplyProgressionCard)}
            onClick={openClanSupplyProgression}
            onMouseDown={sendClickSoundCommand}
            onMouseEnter={sendHoverSoundCommand}
        >
            <div
                className={styles.tankImage}
                style={{ '--tank-image': `url(${
                isTankAvailable ?
                    mapSettings.prize.availableImage :
                    mapSettings.prize.notAvailableImage
                })` }}
            />
            <h2>{CLAN_SUPPLY_PROGRESSION_TITLE}</h2>
            <div className={styles.explored}>
                <div className={styles.effect}>
                    <div className={styles.line} />
                </div>
                <p
                    className={styles.exploredText}
                    data-tip
                    data-for={tooltipId}
                >
                    {mapProgress.regionsUnlocked === mapSettings.regionsCount ?
                        CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED :
                        CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED(
                            <span className={styles.exploredCurrent}>{explodedValue}</span>,
                            <span className={styles.exploredCount}>{countValue}</span>,
                            <span className={styles.exploredDivider}>{CLAN_SUPPLY_SLASH}</span>,
                        )
                    }
                </p>
                <Tooltip id={tooltipId}>
                    <p className={styles['tooltip-message']}>
                        {CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP}
                    </p>
                </Tooltip>
                <div className={classNames(styles.effect, styles.effect__rotated)}>
                    <div className={styles.line} />
                </div>
            </div>
            <ClanSupplyFooterProgression
                tankStatus={mapProgress.finalRegion.status}
                type={mapSettings.prize.type}
                level={mapSettings.prize.level}
                title={mapSettings.prize.title}
                isNewStageAvailable={tourCoin >= mapProgress.cheapestRegionPrice}
            />
        </div>
    )
})

ClanSupplyProgressionCard.propTypes = {
    tourCoin: PropTypes.number.isRequired,
}

export default ClanSupplyProgressionCard



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyProgressionCard.jsx